import { useTranslation } from "react-i18next";
import LegalPage, { LegalSection } from "@/components/LegalPage";

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const sections = t("legal.privacy.sections", { returnObjects: true }) as LegalSection[];

  return (
    <LegalPage
      seoTitle={t("legal.privacy.seoTitle")}
      seoDescription={t("legal.privacy.seoDescription")}
      keywords={t("legal.privacy.keywords")}
      url="https://masshappy.com/privacidad"
      title={t("legal.privacy.title")}
      sections={Array.isArray(sections) ? sections : []}
      contactTitle={t("legal.privacy.contactTitle")}
      contactIntro={t("legal.privacy.contactIntro")}
      contactLines={[
        t("legal.privacy.email"),
        t("legal.privacy.phone"),
        t("legal.privacy.address"),
      ]}
      updated={t("legal.privacy.updated")}
    />
  );
};

export default PrivacyPolicy;
